import { IDelayOptions } from "src/pages/FlightEditor/DelaysForm/DelaysForm";
import { DelayCodeSortOption } from "src/redux/reducers/UISettingsReducer";

export function formatDelayCode(delay: IDelayOptions, delayCodeFormat: string[]): string {
  return delayCodeFormat
    .map((key) => {
      if (key.includes(".")) {
        const parts = key.split(".");
        let value: any = delay; // start with the `delay` object and access nested properties
        for (const part of parts) {
          if (value && part in value) {
            value = value[part as keyof typeof value]; // access next nested level
          } else {
            return "";
          }
        }
        return String(value);
      } else if (key in delay) {
        return String(delay[key as keyof IDelayOptions]);
      } else {
        return key;
      }
    })
    .join("");
}

export const sortDelayOptions = (
  options: IDelayOptions[],
  delayCodeFormat: string[],
  sortBy?: DelayCodeSortOption
): IDelayOptions[] => {
  const sorted = [...options];

  if (!sortBy) {
    // No sort specified - keep original order
    return sorted.sort((a: IDelayOptions, b: IDelayOptions) => {
      return formatDelayCode(a, delayCodeFormat) === formatDelayCode(b, delayCodeFormat) ? 1 : 0;
    });
  }

  sorted.sort((a: IDelayOptions, b: IDelayOptions) => {
    switch (sortBy) {
      case DelayCodeSortOption.DelayCodeTitle:
        return a.delayCode.title.localeCompare(b.delayCode.title);
      case DelayCodeSortOption.DelayCodeNumber:
        return a.delayCode.delayNumber - b.delayCode.delayNumber;
      case DelayCodeSortOption.DelayTitle:
        return a.title.localeCompare(b.title);
      default:
        return 0;
    }
  });

  return sorted;
};
